import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  sourceChip: {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.primary.contrastText,
  },
  responsibleChipLabel: {
    pointerEvents: 'auto',
  },
  fieldLabel: {
    fontSize: 11,
    fontWeight: 600,
    color: theme.palette.text.secondary,
    textTransform: 'uppercase',
    letterSpacing: '0.05em',
    marginBottom: theme.spacing(0.5),
  },
  fieldRow: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(0.5),
    marginBottom: theme.spacing(2),
  },
}))

export default useStyles
